import {ReactElement} from "react";
import {Select} from "antd";
import {getClients} from "../../services/ServiceClient";
import {Custom} from "../../utils/refineUtils";
import IClient from "../../interfaces/IClient";

interface IProps {
    editable?: boolean
    client?: IClient
    index?: number
}

export default function ConfigLA3d(props: IProps): ReactElement | null {
    const {clients} = getClients()
    const scenarios: any[] = clients?.find(client => client?.id === "la3d")?.config.scenarios
    return props.editable ?
        <Custom.Item name={[props.index ?? 0, 'config', 'scenario']} label="configClients.la3d.scenario">
            <Select options={scenarios.map(s => ({label: s.name + ' - ' + s.url, value: s.id}))}/>
        </Custom.Item>
        :
        <Custom.IconInfo icon={null} label="configClients.la3d.scenario"
                         value={scenarios.find(s => s.id === props.client?.config.scenario).name}/>
}